import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

async function bootstrap(): Promise<void> {
  // Télémétrie initialisée AVANT le bootstrap pour capter le chargement de page
  // (document-load) et les premières erreurs. Import dynamique : le SDK OTel
  // reste dans un chunk séparé, hors du bundle initial (budgets de build).
  if (environment.telemetry.enabled) {
    try {
      const { initTelemetry } = await import('./app/core/observability/telemetry');
      initTelemetry(environment.telemetry);
    } catch (err) {
      console.error('[telemetry] initialisation échouée', err);
    }
  }

  await bootstrapApplication(App, appConfig);
}

bootstrap().catch((err) => console.error(err));
